import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallBanner = () => {
  const [prompt, setPrompt] = useState(window.__installPrompt || null);
  const [dismissed, setDismissed] = useState(localStorage.getItem("install_dismissed") === "1");
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    const on = () => setPrompt(window.__installPrompt);
    const done = () => setPrompt(null);
    window.addEventListener("installable", on);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("installable", on); window.removeEventListener("appinstalled", done); };
  }, []);

  if (isStandalone() || dismissed || (!prompt && !isIos())) return null;

  const install = async () => {
    if (prompt) {
      prompt.prompt();
      await prompt.userChoice;
      window.__installPrompt = null;
      setPrompt(null);
    } else setIosHelp(true);
  };
  const dismiss = () => { localStorage.setItem("install_dismissed", "1"); setDismissed(true); };

  return (
    <div className="mx-5 mt-3 rounded-2xl border border-[#007AFF]/30 bg-[#007AFF]/10 p-3 text-xs fade-up" data-testid="install-banner">
      <div className="flex items-center justify-between gap-3">
        <span className="text-neutral-300">Add CellCheckPoint to your home screen — one tap starts a test.</span>
        <div className="flex items-center gap-2 shrink-0">
          <button data-testid="install-app-button" onClick={install} className="btn-primary rounded-full px-3 py-1.5 flex items-center gap-1"><Download className="w-3 h-3" /> Install</button>
          <button data-testid="install-dismiss-button" onClick={dismiss} className="text-neutral-500 hover:text-white"><X className="w-4 h-4" /></button>
        </div>
      </div>
      {iosHelp && (
        <div className="mt-2 text-neutral-400 flex items-center gap-1 flex-wrap" data-testid="ios-install-help">
          In Safari tap <Share className="w-3 h-3 inline text-[#007AFF]" /> Share, then <b className="text-white">Add to Home Screen</b>.
        </div>
      )}
    </div>
  );
};
